import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import baseURL from '../baseURL/baseUrl'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin : localStorage.access_token? true : false,
    userRole : localStorage.role,
    showModalAdmin : false,
    statistik : {},
    puskesmas : [],
    puskesmasDetail : {},
    puskesmasId : '',
    newPuskesmas : {},
    loginUser : {},
    newAdmin : {},
    statusSchedule : '',
    schedule : {},
    scheduleId : '',
    vaccines : [],
    newVaccine : {},
    vaccineId : '',
    coordinat : {},
    loading : false,
    search : ''
  },
  mutations: {
    CHANGEMODALADMIN(state,payload){
      console.log('asuk sini');
      console.log(payload, 'ini payload');
      state.showModalAdmin = payload
    },
    LOGIN(state,payload){
      console.log('asup');
      state.loginUser = payload
    },
    SETLOGIN(state,payload){
      state.isLogin = payload
      // state.userId = payload
    },
    SETLOGOUT(state,payload){
      state.isLogin = payload
      state.userRole = ''
    },
    FETCHPUSKESMAS(state,payload){
      state.puskesmas = payload
    },
    PUSKESMASID(state,payload){
      console.log(payload, 'ini id puskesmas');
      state.puskesmasId = payload
    },
    FETCHPUSKESMASDETAIL(state,payload){
      state.puskesmasDetail = payload
    },
    UPDATEPUSKESMAS(state,payload){
      console.log(payload, 'ini di mutation update');
      state.newPuskesmas = payload.formData
      state.puskesmasId = payload.id
    },
    FETCHSTATISTIK(state,payload){
      console.log(payload, ' ini di mutasi statistik');
      state.statistik = payload
    },
    ADDPUSKESMAS(state,payload){
      state.newPuskesmas = payload
    },
    POSTADMIN(state,payload){
      console.log(payload);
      state.newAdmin = payload
    },
    PATCHSTATUS(state,payload){
      console.log(payload);
      state.schedule = payload.schedule
      if(payload.status){
        state.statusSchedule = payload.status
        state.scheduleId = payload.scheduleId
      }
    },
    DELETESCHEDULE(state,payload){
      state.scheduleId = payload
    },
    FETCHVACCINES(state,payload){
      state.vaccines = payload
    },
    POSTVACCINE(state,payload){
      state.newVaccine = payload
    },
    DELETEVACCINE(state,payload){
      state.vaccineId = payload
    },
    COORDINAT(state,payload){
      console.log(payload, 'ini coordinat di store');
      state.coordinat = payload
    },
    SETLOADING(state,payload){
      console.log(payload);
      state.loading = payload
    },
    SEARCHING(state,payload){
      state.search = payload
    }
  },
  actions: {
    loginAdmin(context){
      const userLogin = context.state.loginUser 
      return axios({
        method : 'POST',
        url : `${baseURL}/login`,
        data : userLogin
      })
    },
    fetchPuskesmas(context){
      const name = context.state.search
      console.log(name, 'ini name');
      let url
      if(name || name == ''){
         url = `${baseURL}/puskesmas?searchByName=${name}`
      }else{
         url = `${baseURL}/puskesmas`
      }
      context.commit('SETLOADING', true)
      axios({
        method : 'GET',
        url : url,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
      .then(response => {
        console.log(response);
        let getPuskesmas = response.data
        context.commit('FETCHPUSKESMAS', getPuskesmas)
        context.commit('SETLOADING', false)
        context.commit('SEARCHING', '')
      })
      .catch(err => {
        console.log(err);
      })
    },
    fetchPuskesmasDetail(context){
      context.commit('SETLOADING', true)
      const puskesmasId = context.state.puskesmasId
      console.log(puskesmasId, 'di store fetch puskemas detail');
      axios({
        method : 'GET',
        url : `${baseURL}/puskesmas/${puskesmasId}`,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
      .then(response => {
        let puskesmasDetail = response.data
        console.log(puskesmasDetail);
        context.commit('FETCHPUSKESMASDETAIL', puskesmasDetail)
        context.commit('SETLOADING', false)
        
      })
      .catch(err => {
        console.log(err);
      })
    },
    fetchCorona(context){
      axios({
        method : 'GET',
        url : 'https://vaxin8d-orc.herokuapp.com/covid19/updates'
      })
      .then(response => {
        console.log(response);
        let  getStatistik = response.data.data
        console.log(getStatistik);
        context.commit('FETCHSTATISTIK', getStatistik)
      })
      .catch(err => {
        console.log(err);
      })
    },
    postPuskesmas(context){
      const addNewPuskesmas = context.state.newPuskesmas
      console.log(addNewPuskesmas);
      console.log('asupsini');
      return axios({
        method : 'POST',
        url : `${baseURL}/puskesmas`,
        headers : {
          'access_token' : localStorage.access_token
        },
        data : addNewPuskesmas
      })
    },
    updatePuskesmas(context){
      const puskesmasId = context.state.puskesmasId
      const puskesmasUpdate = context.state.newPuskesmas
      console.log(puskesmasId);
      
      console.log('masuk axios');
      return axios({
        method : 'PUT',
        url : `${baseURL}/puskesmas/${puskesmasId}`,
        headers : {
          'access_token' : localStorage.access_token
        },
        data : puskesmasUpdate
      })
    },
    deletePuskesmas(context){
      const puskesmasId = context.state.puskesmasId
      console.log(puskesmasId, 'store delete id');
      return axios({
        method : 'DELETE',
        url : `${baseURL}/puskesmas/${puskesmasId}`,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
    },
    postAdmin(context){
      const addAdmin = context.state.newAdmin
      return axios({
        method : 'POST',
        url : `${baseURL}/register`,
        headers : {
          'access_token' : localStorage.access_token
        },
        data : addAdmin
      })
    },

    patchUser(context){
      const status = context.state.statusSchedule
      const scheduleId = context.state.scheduleId
      return axios({
        method : 'PATCH',
        url : `${baseURL}/schedules/${scheduleId}`,
        headers : {
          'access_token' : localStorage.access_token
        },
        data : {status : status}
      })
    },
    deleteSchedule(context){
      const scheduleId = context.state.scheduleId
      console.log(scheduleId,'masuk delete schedule store');
      return axios({
        method : 'DELETE',
        url : `${baseURL}/schedules/${scheduleId}`,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
    },
    fetchVaccines(context){
      context.commit('SETLOADING', true)

      axios({
        method : 'GET',
        url : `${baseURL}/vaccines`,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
      .then(response => {
        console.log(response);
        let getVaccines = response.data
        context.commit('FETCHVACCINES', getVaccines)
        context.commit('SETLOADING', false)
      })
      .catch(err => {
        context.commit('SETLOADING', false)

        console.log(err);
      })
    },
    postVaccine(context){
      const vaccine = context.state.newVaccine
      return axios({
        method : 'POST',
        url : `${baseURL}/vaccines`,
        headers : {
          'access_token' : localStorage.access_token
        },
        data : vaccine
      })
    },
    deleteVaccine(context){
      const vaccineId = context.state.vaccineId
      return axios({
        method : 'DELETE',
        url : `${baseURL}/vaccines/${vaccineId}`,
        headers : {
          'access_token' : localStorage.access_token
        }
      })
    }
  },
  modules: {
  }
})
